//Shared properties to define length and regex pattern for fields
export class FieldLength{
    public static NameLength = 50;
    public static NamePattern = '^[a-zA-Z ]*$';
    public static EmailIdPattern = '^[^.][0-9a-zA-z+.\\-\\_]+([.]?[a-zA-Z]+)?@[0-9a-zA-z\\-]+[.]([a-zA-z\\-]{0,10})+[.]?[a-zA-Z\\-]+[.]?[a-zA-Z\\-]+?$';
    public static EmailLength = 100;
    public static AddressLine1Pattern =  "^[a-zA-Z0-9 `~@#%&*()\\-_+;:,\\\"'/\\\\. !@#$%^&*()_+{}|:\"<>?/.,';\\[\\]=\r\n]*$";
    public static PassportPattern = '^[a-zA-Z0-9]{6,25}$';  
    public static CompanyNamePattern = "^[a-zA-Z0-9 `~@#%&*()\\-_+;:,\\\"'/\\\\. !@#$%^&*()_+{}|:\"<>?/.,';\\[\\]=\r\n]*$";
    public static UENRegex = '^[a-zA-Z0-9]*$';
    public static UENLength = 25;
    public static PhoneNumberPattern = '^[0-9]{5,15}$';
    public static CountryCodePattern = '^[+]?[0-9]{1,5}$';
    public static CompanyNameLength = 100;
    public static ContactNumberLength = 15;
    public static MessageBodyRegex = "^[#.0-9a-zA-Z ,\\\\()&@/-]*$"
    public static MessageBodyLength = 500;  
    public static MillisecondsPerMinute = 60000; 
    public static FileNameRegex="^[a-zA-Z0-9 `~@#%&*()\\-_+:,\\\"/\\\\.]*$";
    public static MillisecondsPerSecond = 1000; 
    public static CompanyNameSpecialCharacters = new RegExp("[,.\\-&\\\\/@()']",'g');
    public static FileNameOperatorRegex=new RegExp(/^(?!.*[=';]).*$/i);
}